/*
 * COPYRIGHT Motorola Solutions, INC.
 * ALL RIGHTS RESERVED.
 * MOTOROLA SOLUTIONS CONFIDENTIAL RESTRICTED
 */
import { createAction, props } from '@ngrx/store';
import { ReasonCode } from '../model/reason-code';
import { SystemReasonCode } from '../model/system-reason-code';

export const fetchReasonCodes = createAction('[User] Fetch Reason Codes');
export const fetchReasonCodesSuccess = createAction('[User] Fetch Reason Codes Success', props<{ reasonCodes: ReasonCode[] }>());
export const fetchReasonCodesFail = createAction('[User] Fetch Reason Codes Fail', props<{ payload: string }>());

export const fetchSystemReasonCodes = createAction('[User] Fetch System Reason Codes');
export const fetchSystemReasonCodesSuccess = createAction('[User] Fetch System Reason Codes Success', props<{ systemReasonCodes: SystemReasonCode[] }>());
export const fetchSystemReasonCodesFail = createAction('[User] Fetch System Reason Codes Fail', props<{ payload: string }>());

